export default {"src":"/_next/static/media/yes.63524fd3.svg","height":28,"width":29,"blurWidth":0,"blurHeight":0};